import React from 'react';
import { LUX_CSS, useLuxMotion } from './LuxShared';
import ProductShowcase from './ProductShowcase';
import ContactButton from './ContactButton';

const ProductsLux = () => {
  const rootRef = useLuxMotion();
  return (
    <div className="fx-root" ref={rootRef}>
      <style>{LUX_CSS}</style>

      <section className="fx-hero fx-mono fx-tall">
        <video className="fx-hero-video" muted loop playsInline autoPlay preload="auto" src="/nh-media/products-hero.mp4" />
        <div className="fx-orb fx-orb-a" />
        <div className="fx-orb fx-orb-b" />
        <div className="fx-hero-scrim" />
        <div className="fx-hero-inner">
          <h1 className="fx-reveal">The products <span className="fx-accent">we've shipped.</span></h1>
          <p className="fx-reveal">Real software, built end to end by the same team you'd be working with — two live proofs of how we ship.</p>
        </div>
      </section>

      <ProductShowcase />

      <ContactButton
        title="Want the same proof on your problem?"
        subtitle="Bring the idea. We'll show you what shipping fast actually looks like."
      />
    </div>
  );
};

export default ProductsLux;
